import Select from "../Fields/Select";
import { sectionSettings, metaobject, icons, lengthHelp, formatMoney, getSrcSet } from "../../Helpers/WindowHelpers";
import { getFoldDirections, getPanels, getStrapLocations, clearValues, updateVariantObject, updateVariants, getShape } from "../../Helpers/FormikUpdateFunctions";
import { useFormikContext } from "formik";
import { useEffect } from "react";
import ModalSection from "../Fields/ModalSection";
import VariantInput from "../Fields/VariantInput";
import Heading from "../Heading";
import BonusContent from "../Fields/BonusContent";
import Message from "../Fields/Message";
import Checkbox from "../Fields/Checkbox";
import Input from "../Fields/Input";
import SkirtAndStrapLengths from "../Sections/SkirtAndStrapLengths";
interface Step3Interface {

}

const Step3 = ({ }: Step3Interface) => {
    const context = useFormikContext<any>();
    const panel = getPanels(context.values?.shape).find((panel) => panel.number_of_panels == context.values?.panels);
    const foldDirection = getFoldDirections(context.values?.shape, context.values?.panels).find((foldDirection) => foldDirection.option_select_name == context.values.fold_direction);
    const currentShape = getShape(context.values?.shape);
    const isCustomShape = context.values?.customShape || false;
    let strapLocationSubtext = null;

    useEffect(() => {
        const errorKeys = Object.keys(context.errors);

        if (!!errorKeys.length) {
            const firstAvailableElementId = errorKeys.find((key) => document.querySelector(`#${key}`) as HTMLElement)
            if (!firstAvailableElementId) return;
            const firstElement = document.querySelector(`#${firstAvailableElementId}`) as HTMLElement;
            if (firstElement !== document.activeElement) {
                firstElement.focus();
                firstElement.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
            }
        }
    }, [context.isSubmitting]);

    const updatePanels = (value: string) => {
        context.setFieldValue('panels', value);
        context.setFieldTouched('panels', false);
        context.setFieldValue('customStrapLocation', false);
        clearValues(['fold_direction', 'strap_location', 'custom_tiedown_distance'], context);
    }

    const updateFoldDirection = (value: string) => {
        context.setFieldValue('fold_direction', value);
        context.setFieldTouched('fold_direction', false);
        context.setFieldValue('customStrapLocation', false);
        clearValues(['strap_location', 'custom_tiedown_distance'], context);
    }

    const updateStrapLocation = (value: string) => {
        context.setFieldValue('strap_location', value);
        context.setFieldTouched('strap_location', false);
        context.setFieldValue('customStrapLocation', false);
        clearValues(['custom_tiedown_distance'], context);
        updateStrapLocationInfo(value);
    }

    const updateStrapLocationInfo = (value: string) => {
        const infoItem = currentShape.strap_location_info.find((item) => item.name == value);
        if(infoItem){
            strapLocationSubtext = `<span class="configurator-field-help d--block">${infoItem?.info}</span>`;
        }
    }

    const updateStrapOption = (value: string) => {
        const variant = metaobject.strap_options.find((item) => item.id == value);
        updateVariantObject('strap_option', variant, context, 3);
    }

    const updateAdditionalStrapOptions = (value: string) => {
        const variant = metaobject.additional_strap_options.find((item) => item.id == value);
        updateVariants('additional_strap_options', variant, context, 3);
    }

    if (currentShape && context.values?.strap_location) {
        updateStrapLocationInfo(context.values.strap_location);
    }

    return (
        <>
            <Heading
                level={4}
                text={metaobject.text.fold_strap_and_skirt_heading}
            />
            <div className="d--flex sm--flex-column">
                <div className="d--flex flex-column gap-16 width--100">

                    {context.values.customShape
                        ? <Message message={metaobject.text.custom_shape_fold_notice} additionalClasses="mb-20" />
                        : null}
                    {!isCustomShape && currentShape?.panels?.length > 1 ? (<>
                        <Select
                            name={'panels'}
                            label={sectionSettings.label_panels}
                            defaultText={sectionSettings.label_panels_select}
                            options={
                                getPanels(context.values.shape).map((panel) => {
                                    return {
                                        text: panel.number_of_panels,
                                        value: panel.number_of_panels
                                    }
                                }) ?? []}
                            onChange={updatePanels}
                            subtext={metaobject.text.panels_subtext}
                        ></Select>
                    </>
                    ) : null}

                    {!isCustomShape && <Select
                        name={'fold_direction'}
                        label={sectionSettings.label_fold_direction}
                        defaultText={sectionSettings.label_fold_direction_select}
                        disabled={!context.values?.panels}
                        options={getFoldDirections(context.values.shape, context.values.panels).map((foldDirection) => {
                            return {
                                text: foldDirection.option_select_name,
                                value: foldDirection.option_select_name
                            }
                        })}
                        onChange={updateFoldDirection}
                    ></Select>}
                    {!isCustomShape && <Select
                        name={'strap_location'}
                        label={sectionSettings.label_strap_location}
                        defaultText={sectionSettings.label_strap_location_select}
                        subtext={strapLocationSubtext ?? null}
                        disabled={!context.values?.fold_direction}
                        options={getStrapLocations(context.values.shape, context.values.panels, context.values.fold_direction).map((strapLocation) => {
                            return {
                                text: strapLocation.option_select_name,
                                value: strapLocation.option_select_name
                            }
                        }) ?? []}
                        onChange={updateStrapLocation}
                    ></Select>}
                    {metaobject.strap_locations_for_custom_inset_measurements?.includes(context.values.strap_location) &&
                        <Checkbox name="customStrapLocation" text={sectionSettings.label_custom_inset_measurements} />}
                    {context?.values?.customStrapLocation &&
                        <Input
                            name="custom_tiedown_distance"
                            type="number"
                            min={0}
                            max={999}
                            label={sectionSettings.label_custom_tie_down_distance} />}
                    <SkirtAndStrapLengths />
                    {metaobject.text.length_help && lengthHelp.name !== ""
                    ? <ModalSection
                        classes={'d--flex gap-10 text--sm align-items--center'}
                        buttonBody={`${icons.info} <span class="link">${metaobject.text.length_help}</span>`}>
                        <BonusContent
                            title={metaobject.text.length_help}
                            content={lengthHelp}></BonusContent>
                    </ModalSection>
                    : null}
                </div>
                <div className="width--100">
                    {
                        foldDirection?.strap_locations &&
                        <img
                            className="strap-locations-diagram d--block mx-auto"
                            srcSet={getSrcSet(foldDirection?.strap_option_image, [356])}
                            sizes={'356px'}
                            alt={foldDirection?.strap_option_image ?? "placeholder"}
                            height={356}
                            width={356}
                            loading="lazy"
                            role="presentation" />
                    }
                </div>
            </div>
            {metaobject.strap_options?.length > 0 ? (
                <Heading
                    level={4}
                    text={metaobject.text.strap_options_heading}
                />
            ) : null}
            {metaobject.strap_options?.length > 0 ? (
                <VariantInput
                    name="strap_option"
                    variants={metaobject.strap_options}
                    inputType="radio"
                    onChange={(e: Event) => updateStrapOption((e.currentTarget as HTMLInputElement).value)}
                    step={3}
                ></VariantInput>
            ) : null}
            {metaobject.additional_strap_options?.length > 0 ? (
                <Heading
                    level={4}
                    text={metaobject.text.additional_strap_options_heading}
                />
            ) : null}
            {metaobject.additional_strap_options?.length > 0 ? (
                <VariantInput
                    name="additional_strap_options"
                    variants={metaobject.additional_strap_options}
                    inputType="checkbox"
                    onChange={(e: Event) => updateAdditionalStrapOptions((e.currentTarget as HTMLInputElement).value)}
                    step={3}
                ></VariantInput>
            ) : null}
        </>
    );
};

export default Step3;